import React from "react"
import PropTypes from "prop-types"
import { geocodeByPlaceId } from "react-places-autocomplete"
import { CircularProgress } from "@material-ui/core"
import MUIPlacesAutocomplete from "./MUIPlacesAutocomplete"

let geocodeTimeout = null
let geocodeTimeoutDelay = 1000
class PlacesSearchAutocomplete extends React.Component {
    state = {
        inputIsFocused: false,
        geolocationLoading: false,
    }

    componentWillUnmount() {
        if (geocodeTimeout) {
            clearTimeout(geocodeTimeout)
        }
    }

    parseAddressFromResult = result => {
        if (!result || !result[0]) {
            return null
        }

        const address = {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            zip: "",
            lat: null,
            long: null,
            fullAddress: "",
        }

        result[0].address_components.forEach(addressComponent => {
            if (addressComponent.types.includes("street_number")) {
                address.addressLine1 = addressComponent.long_name + " " + address.addressLine1
            } else if (addressComponent.types.includes("route")) {
                address.addressLine1 += addressComponent.long_name
            } else if (
                (addressComponent.types.includes("locality") && addressComponent.types.includes("political")) ||
                (addressComponent.types.includes("sublocality") && addressComponent.types.includes("political"))
            ) {
                address.city = addressComponent.long_name
            } else if (addressComponent.types.includes("administrative_area_level_1")) {
                address.state = addressComponent.short_name
            } else if (addressComponent.types.includes("postal_code")) {
                address.zip = addressComponent.long_name.replace(/\s/g, "")
            }
        })

        address.lat = result[0].geometry.location.lat()
        address.long = result[0].geometry.location.lng()
        address.fullAddress = result[0].formatted_address

        return address
    }

    onSuggestionSelected = suggestion => {
        this.setState({
            inputIsFocused: false,
        })

        geocodeByPlaceId(suggestion.place_id)
            .then(result => {
                if (this.props.onChangeCallback) {
                    this.props.onChangeCallback(this.parseAddressFromResult(result))
                }
            })
            .catch(error => console.error("Error during google map suggestion parsing", error))
    }

    useMyPositionOptionClicked = () => {
        if (!this.state.geolocationLoading) {
            this.setState({
                geolocationLoading: true,
            })
        }

        if (this.props.useMyPositionClickedCallback) {
            this.props.useMyPositionClickedCallback()
        }

        navigator.geolocation.getCurrentPosition(
            position => {
                const geocoder = new window.google.maps.Geocoder()
                if (geocoder) {
                    const latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude)
                    geocoder.geocode({ latLng: latlng }, (results, status) => {
                        if (status === window.google.maps.GeocoderStatus.OK) {
                            if (results[1]) {
                                if (geocodeTimeout) {
                                    geocodeTimeout = null
                                }

                                const userLat = position.coords.latitude
                                const userLong = position.coords.longitude

                                if (this.props.useMyPositionSuccessCallback) {
                                    this.props.useMyPositionSuccessCallback(
                                        userLat,
                                        userLong,
                                        results[1].formatted_address
                                    )
                                }
                                this.setState({
                                    geolocationLoading: false,
                                })
                            }
                        } else if (status === window.google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                            geocodeTimeout = window.setTimeout(() => {
                                this.useMyPositionOptionClicked()
                                geocodeTimeoutDelay += 100
                            }, geocodeTimeoutDelay)
                        }
                    })
                }
            },
            () => {
                alert("Geolocation is not available")
                this.setState({
                    geolocationLoading: false,
                })
            }
        )
    }

    render() {
        return (
            <div>
                <MUIPlacesAutocomplete
                    showUseMyPositionOption={this.props.showUseMyPositionOption || false}
                    useMyPositionOptionClickedCallback={this.useMyPositionOptionClicked}
                    isOpen={this.state.inputIsFocused}
                    onSuggestionSelected={this.onSuggestionSelected}
                    textFieldProps={{
                        ...this.props.textFieldProps,
                        onClick: e => {
                            if (e.target.select) {
                                e.target.select()
                            }
                            this.setState({ inputIsFocused: true })
                        },
                        onFocus: e => {
                            e.target.select()
                            this.setState({ inputIsFocused: true })
                            if (this.props.textFieldProps.onFocus) {
                                this.props.textFieldProps.onFocus(e)
                            }
                        },
                        onBlur: e => {
                            this.setState({ inputIsFocused: false })
                            if (this.props.textFieldProps.onBlur) {
                                this.props.textFieldProps.onBlur(e)
                            }
                        },
                        ...(this.state.geolocationLoading
                            ? {
                                  style: {
                                      opacity: 0.65,
                                      pointerEvents: "none",
                                  },
                                  InputProps: {
                                      endAdornment: (
                                          <div style={{ paddingTop: "5px" }}>
                                              <CircularProgress size={22} />
                                          </div>
                                      ),
                                      ...(this.props.textFieldProps.InputProps || {}),
                                  },
                              }
                            : {}),
                        InputLabelProps: {
                            shrink: this.state.inputIsFocused || Boolean(this.props.textFieldProps.value),
                            ...(this.props.textFieldProps.InputLabelProps || {}),
                        },
                    }}
                    renderTarget={() => <div />}
                />
            </div>
        )
    }
}

PlacesSearchAutocomplete.propTypes = {
    showUseMyPositionOption: PropTypes.bool.isRequired,
    useMyPositionSuccessCallback: PropTypes.func.isRequired,
    useMyPositionClickedCallback: PropTypes.func.isRequired,
    onChangeCallback: PropTypes.func.isRequired,
    // eslint-disable-next-line
    textFieldProps: PropTypes.object.isRequired,
}

export default PlacesSearchAutocomplete



// WEBPACK FOOTER //
// ./src/components/MUIPlacesAutocomplete/PlacesSearchAutocomplete.jsx